import { render } from "./JsonPanel.vue?vue&type=template&id=4669854b&scoped=true"
import script from "./JsonPanel.vue?vue&type=script&lang=js"
export * from "./JsonPanel.vue?vue&type=script&lang=js"

import "./JsonPanel.vue?vue&type=style&index=0&id=4669854b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4669854b"]])

export default __exports__